// @flow
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useToast } from '@fortress-technology-solutions/fortress-component-library/contexts';

type Severity = 'info' | 'warning' | 'success' | 'error';

const useIntlToast = () => {
  const { showToast } = useToast();
  const intl = useIntl();

  return useCallback(
    (severity: Severity, intlMessageId, intlValues) =>
      showToast(
        intl.formatMessage({ id: intlMessageId }, intlValues),
        severity,
      ),
    [intl, showToast],
  );
};

export default useIntlToast;
